import { IManhattanFactory } from "../manhattan/types";

export const SSOTestDataFactory: IManhattanFactory = class SSOExampleDataFactory {

  static create(data: any) {
    const landingPages = ['device-list', 'device-overview', 'campaign-list', 'campaign-overview', 'cart-overview', 'checkout-process', 'transaction-status', 'sim-only'];
    return {
      platform: data.app,
      roles: data.roles,
      landingPages
    };
  }

};
